import { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/router'
import LocationSearch from '../hero/hero-rslhome/FromTo'
import Location from '../hero/hero-rslhome/AddressBookRideActivities'
import Skeleton from '@mui/material/Skeleton'
import BusPickupLocation from '../hero/hero-rslhome/BusPickupLocation'
import HotelDestinationCity from '../hero/hero-rslhome/bus/ActivityDestinationCityBus'
import BusRentalTime from '../hero/hero-rslhome/BusRentalTime'
import BusRentalCalanderFrom from '../hero/hero-rslhome/bus/BusRentalCalanderFrom'
// import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from '@mui/material/CircularProgress'


import { useDispatch, useSelector } from '../../redux/store'
import { searchBus, busCategory, busTypes } from '../../redux/slices/bus'
import AuocompleteType from '../../components/autocomplete/AutocompleteBusType'
import CarDropLocation from '../hero/hero-rslhome/CarDropLocation'
import moment from 'moment'
import { createTheme, ThemeProvider } from '@mui/material/styles'

// Create a custom theme with the desired CircularProgress color
const customTheme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Change to your desired color
          width: '20px !important',
          height: '20px !important'
        }
      }
    }
  }
})

const ActivitiesRSL = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const autocompleteFirst = useRef()
  const autocompleteNext = useRef()
  const { busSearchRes, busCategoryRes, busTypeRes } = useSelector(
    state => state.bus
  )
  const [bookPickUp, setBookPickUp] = useState(null)
  const [country, setCountry] = useState(null)
  const [checkInDate, setCheckInDate] = useState('')
  const [checkOutDate, setCheckOutDate] = useState('')
  const [cityValue, setCityValue] = useState([])
  const [timeValue, setTimeValue] = useState('')
  const [cityDropValue, setCityDropValue] = useState('')
  const [bookDropOff, setBookDropOff] = useState(null)
  const [stateCountry, setStateCountry] = useState('')
  const [loader, setLoader] = useState(false)
  const [busType, setBusType] = useState(null)
  const [searchProduct, setSearchProduct] = useState('')
  const [selectedValue, setSelectedValue] = useState(null)
  const [loaderSearch, setLoaderSearch] = useState(false)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [pickup, setPickup] = useState({
    address: '',
    lat: 0,
    lng: 0
  })
  const [drop, setDrop] = useState({
    address: '',
    lat: 0,
    lng: 0
  })

  const [isSubmitClicked, setIsSubmitClicked] = useState(false)
  const [isFormValid, setIsFormValid] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')

  const [pickupDateTime, setPickupDateTime] = useState('')
  const [dropDateTime, setdropDateTime] = useState('')
  const [bookRide, setBookRide] = useState(false)
  const [carRentals, setCarRentals] = useState(true)
  const [btnStatus, setBtnStatus] = useState(true)

  const [loading, setLoading] = useState(true)
  const [focusFirst, setFocusFirst] = useState(true)
  const [focusNext, setFocusNext] = useState(false)

  useEffect(() => {
    if (autocompleteFirst.current) {
      autocompleteFirst.current
        .querySelector('input')
        .focus({ preventScroll: true })
    }
  }, [])

  useEffect(() => {
    if (selectedValue?.name !== '' && selectedValue !== null) {
      if (autocompleteNext.current) {
        autocompleteNext.current
          .querySelector('input')
          .focus({ preventScroll: true })
        setFocusNext(true)
      }
    }
  }, [selectedValue])

  // useEffect(() => {
  //   if (
  //     timeValue &&
  //     timeValue !== "" &&
  //     checkInDate !== "" &&
  //     checkOutDate !== ""
  //   ) {
  //     setIsButtonDisabled(false);
  //   } else {
  //     setIsButtonDisabled(true);
  //   }
  // }, [timeValue, pickupDateTime]);

  useEffect(() => {
    setIsSubmitClicked(false)
    if (
      busType &&
      busType !== null &&
      searchProduct !== '' &&
      checkOutDate !== '' &&
      checkInDate !== ''
    ) {
      setIsButtonDisabled(false)
    } else {
      setIsButtonDisabled(true)
    }
  }, [busType, searchProduct, checkOutDate, checkInDate])

  const handleBookPickUpChange = e => {
    setBookPickUp(e.target.value)
  }

  const handleCountryChange = e => {
    setCountry(e.target.value)
  }

  const handleBookDropOffChange = selectedDropOffBook => {
    setBookDropOff(selectedDropOffBook)
  }

  useEffect(() => {
    // dispatch(busCategory());
    dispatch(busTypes())
  }, [])

  const [isCalled, setIsCalled] = useState(false)
  useEffect(() => {
    setLoading(true)
    setIsCalled(true)

    const timerId = setTimeout(() => {
      if (searchProduct.length >= 3) {
        setCityValue([])
        dispatch(
          searchBus({ query: searchProduct?.length > 0 ? searchProduct : '' })
        )
      } else if (searchProduct.length === 0) {
        dispatch(searchBus({ query: '' }))
      }
    }, 500)

    return () => {
      clearTimeout(timerId)
    }
  }, [searchProduct])

  const handleBooking = () => {
    setIsSubmitClicked(true)
    if (selectedValue !== null && checkInDate !== '' && busType !== null) {
      setLoader(true)

      router.push({
        pathname: '/busBooking/busRentals',
        query: {
          cityName: selectedValue?.cityName,
          name: selectedValue?.name,
          pickupDateTime: moment(checkInDate).format?.('YYYY-MM-DD'),
          pickupDateTimecheckOutDate:
            moment(checkOutDate).format?.('YYYY-MM-DD'),
          pickupTimeValue: timeValue,
          productId: selectedValue?._id,
          type: busType
        }
      })
    } else {
      setIsFormValid(false)
      setErrorMessage('Please fill in all fields.')
    }
  }

  const handlePickupDateTime = newValue => {
    setPickupDateTime(newValue?.format?.('YYYY-MM-DD'))
  }

  const handleDropDateTime = newValue => {
    setdropDateTime(newValue?.format?.('YYYY-MM-DD HH:mm:ss'))
  }

  const [isDropLocationChecked, setIsDropLocationChecked] = useState(false)

  const handleCheckboxChange = event => {
    setIsDropLocationChecked(event.target.checked)
  }

  const handleBookride = () => {
    setBookRide(true)
    setCarRentals(false)
  }
  const handleCarRentals = () => {
    setCarRentals(true)
    setBookRide(false)
  }

  useEffect(() => {
    setLoading(false)
    if (isCalled) {
      if (busSearchRes !== undefined) {
        setIsCalled(false)
        // Create an empty object
        const myObjectDestination = {}
        const childArrayDestination = []
        const myObjectBusList = {}
        const childArrayBusList = []
        const allObjectDestination = {}
        const allArrayDestination = []
        const mainArray = []
        if (busSearchRes?.destination !== undefined) {
          if (busSearchRes?.destination?.length > 0) {
            busSearchRes?.destination.map(data => {
              myObjectDestination.label = 'Destination'
              myObjectDestination.img = '/img/general/flag.png'
              childArrayDestination.push(data)
              myObjectDestination.values = childArrayDestination
              //
            })
          } else {
            myObjectDestination.label = 'Destination'
            myObjectDestination.values = []
          }
        }

        if (busSearchRes?.countryList !== undefined) {
          if (busSearchRes?.countryList?.length > 0) {
            busSearchRes?.countryList.map(data => {
              myObjectBusList.label = 'Buses'
              myObjectBusList.img = '/img/general/iconnew.png'
              childArrayBusList.push(data)
              myObjectBusList.values = childArrayBusList
            })
          } else {
            myObjectBusList.label = 'Buses'
            myObjectBusList.values = []
          }
        }

        if (busSearchRes?.allCityType !== undefined) {
          if (busSearchRes?.allCityType.length > 0) {
            busSearchRes?.allCityType.map(data => {
              allObjectDestination.label =
                data?.countryName || 'Matched Location'
              allObjectDestination.img = '/img/general/iconnew.png'
              allArrayDestination.push(data)
              allObjectDestination.values = allArrayDestination
              //
            })
          } else {
            allObjectDestination.label = 'Matched Location'
            allObjectDestination.values = []
          }
        }

        mainArray.push(
          allObjectDestination,
          myObjectDestination,
          myObjectBusList
        )
        setCityValue(mainArray)
      }
    }
  }, [busSearchRes])

  return (
    <>
      {carRentals && (
        <>
          <div className='activites_rsl y-gap-40'>
            <div className='activites_input'>
              <div
                className={`${isDropLocationChecked
                  ? 'carbooking-dropLocation'
                  : 'CarBooking'
                  } py-5`}
              >
                {/* <BusPickupLocation
                setCityValue={setCityValue}
                cityValue={cityValue}
              /> */}

                <HotelDestinationCity
                  setCityValue={setCityValue}
                  cityValue={cityValue}
                  searchProduct={searchProduct}
                  setSearchProduct={setSearchProduct}
                  setSelectedValue={setSelectedValue}
                  selectedValue={selectedValue}
                  // label="Select your City? *"
                  label='Select your City?'
                  placeholder='Search'
                  setLoading={setLoading}
                  loading={loading}
                  autocompleteFirst={autocompleteFirst}
                  error={
                    isSubmitClicked && selectedValue === null ? true : false
                  }
                  helperText={
                    isSubmitClicked && selectedValue === null ? 'Required' : ''
                  }
                />

                <AuocompleteType
                  label='Bus Type'
                  records={busTypeRes}
                  // records={busSearchRes?.busList}
                  setType={setBusType}
                  type={busType}
                  error={isSubmitClicked && busType === null ? true : false}
                  helperText={
                    isSubmitClicked && busType === null ? 'Required' : ''
                  }
                />

                {isDropLocationChecked ? (
                  <CarDropLocation
                    setCityDropValue={setCityDropValue}
                    cityDropValue={cityDropValue}
                  />
                ) : (
                  ''
                )}

                <div className='d-flex'>
                  <BusRentalCalanderFrom
                    setCheckInDate={setCheckInDate}
                    setCheckOutDate={setCheckOutDate}
                    checkInDate={checkInDate}
                    checkOutDate={checkOutDate}
                    error={isSubmitClicked && checkInDate === '' ? true : false}
                    helperText={
                      isSubmitClicked && checkInDate === '' ? 'Required' : ''
                    }
                  />
                </div>


                <ThemeProvider theme={customTheme}>
                  <button
                    className='mainSearch__submit btn-1 button -dark-4 py-10 px-15  bg-dark-3 text-white w-100'
                    onClick={handleBooking}
                  >
                    {loader ? <CircularProgress /> : 'Search'}
                  </button>
                </ThemeProvider>

              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default ActivitiesRSL
